export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  home: "nav-home",
  services: "nav-services",
  packages: "nav-packages",
  gallery: "nav-gallery",
  contact: "nav-contact",
  phoneCta: "nav-phone-cta",
  quoteCta: "nav-quote-cta",
  mobileToggle: "nav-mobile-toggle",
  adminLink: "nav-admin-link",
};

export const HERO = {
  root: "hero-root",
  logo: "hero-logo",
  title: "hero-title",
  subtitle: "hero-subtitle",
  primaryCta: "hero-primary-cta",
  phoneCta: "hero-phone-cta",
};

export const SERVICES = {
  root: "services-root",
  detailingCard: "services-detailing-card",
  pressureCard: "services-pressure-card",
};

export const PACKAGES = {
  root: "packages-root",
  card: (slug) => `package-card-${slug}`,
  cta: (slug) => `package-cta-${slug}`,
};

export const GALLERY = {
  root: "gallery-root",
  item: (i) => `gallery-item-${i}`,
};

export const CONTACT = {
  root: "contact-root",
  form: "contact-form",
  name: "contact-name",
  phone: "contact-phone",
  email: "contact-email",
  serviceType: "contact-service-type",
  vehicle: "contact-vehicle",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const FOOTER = {
  root: "footer-root",
  adminLink: "footer-admin-link",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  logout: "admin-logout",
  sidebarQuotes: "admin-sidebar-quotes",
  sidebarGallery: "admin-sidebar-gallery",
  sidebarSettings: "admin-sidebar-settings",
  quotesTable: "admin-quotes-table",
  quoteRow: (id) => `admin-quote-row-${id}`,
  quoteMarkRead: (id) => `admin-quote-mark-read-${id}`,
  quoteDelete: (id) => `admin-quote-delete-${id}`,
  galleryAddUrl: "admin-gallery-add-url",
  galleryAddTitle: "admin-gallery-add-title",
  galleryAddCategory: "admin-gallery-add-category",
  galleryAddSubmit: "admin-gallery-add-submit",
  galleryUploadFile: "admin-gallery-upload-file",
  galleryUploadSubmit: "admin-gallery-upload-submit",
  galleryDelete: (id) => `admin-gallery-delete-${id}`,
  settingsForm: "admin-settings-form",
  settingsSave: "admin-settings-save",
  settingsLogoUpload: "admin-settings-logo-upload",
};
